import { Helmet } from "react-helmet";
import BlogLayout from "../section/blog/blog-layout";

const BlogPage = () => {
    <Helmet>
        <title>Blogs | Travel-Tech & Tourism Trends</title>
        <meta name="description" content="Read expert insights on travel technology, tourism trends, platform updates, and digital transformation in Sri Lanka’s tourism sector through the Digital Tourism blog." />
        <meta name="keywords" content="travel tech blog, tourism trends Sri Lanka, digital tourism insights, travel technology articles" />
    </Helmet>

    return (
        <>
            <BlogLayout />
        </>
    );
}

export default BlogPage;